import { CircularProgress } from '@chakra-ui/react';
import type { OperationStatus } from '../BulkOperationQueue.interface';
import { KText } from '@/ui-library/components/text';
import { CompletedCheckBadge } from '@/components/shared/CompletedCheckBadge';

interface StatusIndicatorProps {
  status: OperationStatus;
  progress?: number;
  errorType?: string;
}

const STATUS = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  FAILED: 'failed',
};

/**
 * Common status indicator component
 * Shows circular progress for in_progress, checkmark for completed, error badge for failed
 */
export const StatusIndicator = ({
  status,
  progress: _progress = 0,
  errorType,
}: StatusIndicatorProps) => {
  if (status === STATUS.IN_PROGRESS) {
    // Show indeterminate spinner for in-progress operations
    // This provides better UX than an empty progress ring when progress is 0 or unknown
    return (
      <CircularProgress
        isIndeterminate
        size="20px"
        thickness="12px"
        color="primary-400"
        trackColor="secondary-200"
      />
    );
  }

  if (status === STATUS.COMPLETED) {
    return <CompletedCheckBadge />;
  }

  if (status === STATUS.FAILED) {
    return (
      <>
        {errorType && (
          <KText size="xs" color="pastel-1-dark">
            {errorType}
          </KText>
        )}
      </>
    );
  }

  // pending or unknown status - show nothing
  return null;
};
